export default "__VITE_ASSET__B_Jnw5pn__"